/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import Grid from "@mui/material/Grid";
import axios from "axios";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useSnackbar } from "notistack";
import useApiRequest from "utils/Apirequest";
import { Autocomplete, TextField } from "@mui/material";
import { CircularProgress } from "@mui/material";

import { useMaterialUIController } from "context";


function AssignDriver() {
  const apiRequest = useApiRequest();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [searchInput, setSearchInput] = useState("");
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const row_data = location.state || {};

  const getInitialValues = () => ({
    first_name: row_data.firstName || "",
    last_name: row_data.lastName || "",
    phone_number: row_data.phoneNumber || "",
    email: row_data.email || "",
    gender: row_data.gender || "",
    date_of_birth: formatDate(row_data.dob) || "",
    state: row_data.state || "",
    city: row_data.city || "",
    rfidTag: row_data.rfidTag || "",
  });
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [day, month, year] = dateString.split("/");
    if (!month || !year) {
      return "";
    }

    const paddedDay = day.padStart(2, "0");
    const paddedMonth = month.padStart(2, "0");

    return `${year}-${paddedMonth}-${paddedDay}`;
  };

  const [values, setValues] = useState(getInitialValues);

  useEffect(() => {
    setValues(getInitialValues);
  }, [row_data]);
  const handleChange = async (e) => {
    const selectedObj = e.target.value;
    if (selectedObj) {
      setSearchInput(
        `${selectedObj?.make} ${selectedObj?.model} ${selectedObj?.variant}`
      );
    }
    setSelectedVehicle(selectedObj);
    setQuery(
      `${selectedObj?.make} ${selectedObj?.model} ${selectedObj?.variant}`
    );
  };

  const fetchVehicles = async (searchTerm = "") => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}vehicle/search/query?query=${searchTerm}`,
        {
          withCredentials: true,

        }
      );
      setResults(res?.data?.data || []);
    } catch (err) {
      console.error("Search error:", err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedVehicle) {
      return enqueueSnackbar("All fields are necessary", { variant: "error" });
    }
    const payload = {
      ARAI_range: selectedVehicle.ARAI_range,
      claimed_range: selectedVehicle.claimed_range,
      connector_type: selectedVehicle.connector_type,
      vehicle_img: selectedVehicle.image,
      vehicle_reg: selectedVehicle?.vehicle_reg,
      make: selectedVehicle.make,
      model: selectedVehicle.model,
      type: selectedVehicle.type,
      variant: selectedVehicle.variant,
      battery_capacity: selectedVehicle.battery_capacity,
    };


    const { data } =
      (await apiRequest(
        "post",
        "users/user/" + values.rfidTag + "/vehicles",
        payload,
        {},
        {  }
      )) || {};
    if (data?.success === true) {
      navigate("/Driver-Management");
    }
  };

  const reset = (event) => {
    event.preventDefault();
    setSelectedVehicle(null);
    setSearchInput("");
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Assign Vehicle to Driver
                </MDTypography>
              </MDBox>

              <MDBox p={4} component="form" role="form">
                <MDBox p={1}>
                  <div className="disabled-input-wrapper">
                    <MDInput
                      disabled
                      type="text"
                      label="Driver ID"
                      value={values.phone_number}
                      name="phone_number"
                      margin="dense"
                      fullWidth
                    />
                  </div>
                </MDBox>
                <style>
                  {`

                  .disabled-input-wrapper div{
                    background-color: ${controller.darkMode ? "#1a2035" : "#f0f2f5"} !important;
                          }
                  `}
                </style>
                <MDBox p={1}>
                  <Autocomplete
                    fullWidth
                    id="select-vehicle"
                    options={results || []}
                    loading={loading}
                    getOptionLabel={(option) =>
                      option ? `${option.vehicle_reg} - ${option.make} ${option.model} ${option.variant}` : ""
                    }
                    value={selectedVehicle || null}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    onOpen={() => {
                      fetchVehicles("");
                    }}
                    onInputChange={(event, newInputValue) => {

                      fetchVehicles(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                      const mockEvent = {
                        target: {
                          name: "vehicle",
                          value: newValue
                        }
                      };
                      handleChange(mockEvent);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Vehicle"
                        placeholder="Search vehicle..."
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.vehicle_reg} - {option.make} {option.model} {option.variant}
                      </li>
                    )}
                  />
                </MDBox>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-around"
                  p={2}
                >
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={reset}
                  >
                    Reset
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={handleSubmit}
                  >
                    Submit
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AssignDriver;
